import { types as t, flow } from 'mobx-state-tree';
import supplierPrefixesApi from 'shared/api/supplierPrefixes';

export const SupplierPrefix = t.model('SupplierPrefix', {
  prefix: t.number,
  supplier_id: t.number,
  name: t.string,
  country_id: t.string,
  country_name: t.string,
  country_iso: t.string,
});

const BaseSupplierPrefixesModel = t.model('BaseSupplierPrefixesModel', {});

const SupplierPrefixesModel = t.model('SupplierPrefixesModel', {
  supplierPrefixes: t.optional(t.array(SupplierPrefix), []),
});

export const SupplierPrefixesDataModel = t
  .compose(BaseSupplierPrefixesModel, SupplierPrefixesModel)
  .actions(self => ({
    fetchSupplierPrefixes: flow(function* fetchSupplierPrefixes() {
      const response = yield supplierPrefixesApi.getSupplierPrefixes();
      if (response && response.data && response.data.items) {
        self.supplierPrefixes = response.data.items as any;
      }
      return response;
    }),
  }));
